import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Router } from '@angular/router'
import { NzNotificationService } from 'ng-zorro-antd'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    public router: Router,
    private http: HttpClient,
    private notificationService: NzNotificationService,
  ) {}

  private static authBody(email: string, password: string) {
    return new HttpParams()
      .set('grant_type', environment.auth.grand_type)
      .set('scope', environment.auth.scope)
      .set('client_id', environment.auth.client_id)
      .set('client_secret', environment.auth.client_secret)
      .set('username', email)
      .set('password', password)
  }

  async login(email: string, password: string): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })

    const body = AuthService.authBody(email, password)

    await this.http.post(`${environment.auth.url}`, body, { headers }).subscribe(
      (response: any) => {
        this.router.navigate(['dashboard'])
      },
      (error: any) => {
        this.router.navigate(['auth/login'])
        this.notificationService.error(error.error, error.error_description)
      },
    )
  }

  async logout() {
    await this.router.navigate(['auth/login'])
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('auth.token')
    return token !== null
  }
}
